$(document).ready(function () {
  const $form = $('#add-to-cart-form');
  const $variantSelects = $form.find('select');
  const $variantIdInput = $form.find('input[name="id"]');

  function updateVariantId() {
    const selectedOptions = $variantSelects.map(function () {
      return $(this).val();
    }).get();

    const matchingVariant = variants.find(variant => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });

    if (matchingVariant) {
      $variantIdInput.val(matchingVariant.id);
    }
  }

  // Attach event listeners to update variant ID on selection
  $variantSelects.on('change', updateVariantId);
});